import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Params } from '@angular/router';
import { PeopleService } from '../../shared/services/index';
import { BaseModalPageComponent } from '../../base-modal.component';
import { Person } from '../../shared/models';

@Component({
    templateUrl: './edit-json.component.html',
    standalone: false
})
export class EditPersonJsonPageComponent extends BaseModalPageComponent implements OnInit {
  public person: Person;
  public personId: string;
  public processing = false;

  constructor(
    location: Location,
    private activatedRoute: ActivatedRoute,
    private peopleService: PeopleService,
    private cdf: ChangeDetectorRef
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['personId'];
      if (id == null) this.cancel();

      this.personId = id;

      this.initData();
    });
  }

  public cancel() {
    this.goToBack();
  }

  savePerson(model: any): void {
    this.processing = true;
    this.peopleService.updatePersonEntity(this.personId, model).subscribe((res) => {
      this.processing = false;
      this.goToBack();
    });
  }

  initData(): void {
    this.peopleService.getPersonEntity(this.personId).subscribe((res) => {
      this.person = res;
      this.cdf.detectChanges();
    });
  }
}
